var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "approval-checklist-detail" },
    [
      _c("approval-search", {
        staticStyle: { "min-width": "1200px" },
        attrs: {
          "show-btn": true,
          "show-batch-btn": _vm.showBatchBtn,
          status: _vm.status,
          filter: _vm.filter,
          "show-initiate-btn": _vm.showInitiateBtn,
          "show-print-btn":
            _vm.showPrintBtn && _vm.documentConfigId === _vm.BILL_PAYMENT.code,
          "view-source": _vm.viewSource,
          type: _vm.type,
          "document-config-id": _vm.documentConfigId,
          "per-config-name": _vm.perConfigName,
          "grid-refresh-id": _vm.gridRefreshId
        },
        on: {
          "update:perConfigName": function($event) {
            _vm.perConfigName = $event
          },
          "update:per-config-name": function($event) {
            _vm.perConfigName = $event
          },
          "update:gridRefreshId": function($event) {
            _vm.gridRefreshId = $event
          },
          "update:grid-refresh-id": function($event) {
            _vm.gridRefreshId = $event
          },
          toQuery: _vm.toQuery,
          toBatchApproval: _vm.toBatchApproval,
          toBatchReject: _vm.toBatchReject,
          toInitiate: _vm.toInitiate,
          toPrint: _vm.toPrint,
          toCancel: _vm.toCancel
        }
      }),
      _c("approval-list-grid", {
        ref: "approvalListGrid",
        attrs: {
          "config-module": _vm.configModule,
          type: _vm.type,
          "document-config-id-prop": _vm.documentConfigId,
          "per-config-name": _vm.perConfigName,
          "grid-refresh-id": _vm.gridRefreshId,
          total: _vm.filter.total,
          status: _vm.status,
          "row-data": _vm.rowData
        },
        on: { toQuery: _vm.toQuery, changeSelected: _vm.changeSelected }
      }),
      _c("batch-submit-or-approve-dialog", {
        attrs: {
          visible: _vm.batchSubmitOrApproveDialog.visible,
          "row-data": _vm.batchSubmitOrApproveDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchSubmitOrApproveDialog, "visible", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.initiateDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_InitiateApproval"),
            width: "450px",
            "custom-class": "cargo-form-dialog"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.initiateDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { "margin-left": "auto" },
              attrs: { "label-width": "70px", "label-position": "left" }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_InitiateForm") } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      "tag-value": "code",
                      "static-options": _vm.initiateDialog.workflowTypes
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.initiateDialog.formId = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: { "padding-right": "30px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
              ),
              _c("el-button", { on: { click: _vm.initiateHandleClose } }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          },
          selectedTemplate: _vm.updatePrintField
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }